import { FC, useMemo } from "react";
import { Pagination, Navigation } from "swiper";
import { Swiper, SwiperSlide } from "swiper/react";
import moment from "moment";
import StarRate from "../../../components/StarRate";
import StarRateNewTrustScore from "../../../components/StarRate2.0";
import { fnRatingDisplay } from "../../../components/rateDisplay";
import { IWidgetTemplate } from "../../../interfaces/widget-template";
import { ReachClick } from "../../../utils/core";
import "swiper/css";
import "swiper/css/navigation";

const LOGO_MARK = `${process.env.PUBLIC_URL}/images/logos/logo-mark.webp`;

const SWIPER_BREAKPOINTS = {
  640: { slidesPerView: 1 },
  768: { slidesPerView: 2 },
  1024: { slidesPerView: 3 },
};

const SWIPER_MODULES = [Pagination, Navigation];

const WidgetTemplate1: FC<IWidgetTemplate> = ({
  company,
  score,
  review,
  theme,
}) => {
  const isDark = theme === "dark";
  const companyId = company?.companyId;

  const payload = useMemo(
    () => ({ companyId, widgetId: 1 as const }),
    [companyId],
  );

  const companyUrl = useMemo(
    () =>
      `https://www.trustfinance.com/companies/${companyId}?utm_source=widget&utm_medium=banner&utm_campaign=carousel`,
    [companyId],
  );

  return (
    <div
      className={`overflow-hidden d-flex justify-content-center row${
        isDark ? " text-white" : ""
      }`}
    >
      <a
        className="text-decoration-none"
        style={{ color: "unset" }}
        href={companyUrl}
        target="_blank"
        rel="noreferrer noopener"
        onClick={() => ReachClick(payload)}
      >
        <div className="d-flex justify-content-center flex-column align-items-center">
          <h4>{fnRatingDisplay(score?.score)}</h4>
          <StarRateNewTrustScore value={score?.score} size={32} />
          <div className="my-2">based on {score?.totalReview} reviews</div>
          <div className="d-flex align-items-center">
            <img src={LOGO_MARK} alt="TrustFinance" width={32} height={32} />
            <span style={{ fontSize: 18, marginLeft: 4, fontWeight: "bold" }}>
              TrustFinance
            </span>
          </div>
        </div>
        <div>
          <Swiper
            breakpoints={SWIPER_BREAKPOINTS}
            spaceBetween={30}
            loop
            pagination={{ clickable: true }}
            navigation
            modules={SWIPER_MODULES}
            className="mySwiper"
          >
            {review?.data?.map((item) => (
              <SwiperSlide key={item.id}>
                <div>
                  <StarRate value={item.score} size={18} />
                  <h5 className="text-review-widget mt-2">{item.title}</h5>
                  <p className="text-review-widget fs-12 mb-2">
                    {item.description}
                  </p>
                  <div className="d-flex">
                    <span className="fs-12 fw-bold text-nowrap line-clamp-1">
                      {item.user?.displayName}
                    </span>
                    <div
                      className={`fs-12 text-review-widget ${
                        isDark ? "text-white" : "text-black-50"
                      }`}
                    >
                      ,&nbsp;
                      {moment(item?.createdAt).fromNow()}
                    </div>
                  </div>
                </div>
              </SwiperSlide>
            ))}
          </Swiper>
          <div className="p-2">Showing our latest reviews</div>
        </div>
      </a>
    </div>
  );
};

export default WidgetTemplate1;
